/**
 * @generated SignedSource<<1f74b081fc2e1a138cb36edbdf3c62b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type QUANTITY_LOCKED_REASON = "FIXED_PRICE" | "FIXED_PRICE_PERIOD" | "FIXED_PRICE_DELIVERABLE" | "%future added value";
export type UpdateInvoiceInput = {
  id?: string | null;
  name?: string | null;
  currency?: string | null;
  invoiceReference?: string | null;
  invoiceType?: string | null;
  status?: string | null;
  dueDay?: number | null;
  dueMonth?: number | null;
  dueYear?: number | null;
  createdDay?: number | null;
  createdMonth?: number | null;
  createdYear?: number | null;
  notes?: string | null;
  entries?: ReadonlyArray<InvoiceEntryInput | null> | null;
  payments?: ReadonlyArray<InvoicePaymentInputType | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type InvoiceEntryInput = {
  id?: string | null;
  name?: string | null;
  projectId?: string | null;
  quantity?: number | null;
  quantityText?: string | null;
  unitPrice?: number | null;
  discount?: number | null;
  tax?: number | null;
  description?: string | null;
  timeRegIds?: ReadonlyArray<string | null> | null;
  expenseItemIds?: ReadonlyArray<string | null> | null;
  periodIds?: ReadonlyArray<string | null> | null;
  deliverableIds?: ReadonlyArray<string | null> | null;
  deliverableAmounts?: ReadonlyArray<DeliverableInvoiceAmountInput> | null;
  externalRefs?: ReadonlyArray<ExternalRef | null> | null;
  quantityLockedReason?: QUANTITY_LOCKED_REASON | null;
};
export type DeliverableInvoiceAmountInput = {
  deliverableId: string;
  amount: number;
};
export type ExternalRef = {
  key?: string | null;
  value?: string | null;
};
export type InvoicePaymentInputType = {
  id?: string | null;
  notes?: string | null;
  amount?: number | null;
  day?: number | null;
  month?: number | null;
  year?: number | null;
};
export type updateInvoiceMutation$variables = {
  input: UpdateInvoiceInput;
};
export type updateInvoiceMutation$data = {
  readonly updateInvoice: {
    readonly invoice: {
      readonly invoiceReference: string | null;
      readonly name: string | null;
      readonly currency: string | null;
      readonly invoiceType: string | null;
      readonly status: string | null;
      readonly dueDay: number | null;
      readonly dueMonth: number | null;
      readonly dueYear: number | null;
      readonly createdDay: number | null;
      readonly createdMonth: number | null;
      readonly createdYear: number | null;
      readonly notes: string | null;
      readonly paymentStatus: string | null;
      readonly entries: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly name: string | null;
            readonly quantity: number | null;
            readonly quantityText: string | null;
            readonly unitPrice: number | null;
            readonly discount: number | null;
            readonly tax: number | null;
            readonly description: string | null;
            readonly quickbooksItemOrService: string | null;
          } | null;
        } | null> | null;
      } | null;
      readonly payments: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
            readonly notes: string | null;
            readonly amount: number | null;
            readonly day: number | null;
            readonly month: number | null;
            readonly year: number | null;
            readonly createdAt: string | null;
            readonly createdBy: {
              readonly fullName: string | null;
            } | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};
export type updateInvoiceMutation = {
  variables: updateInvoiceMutation$variables;
  response: updateInvoiceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceReference",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueDay",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueMonth",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueYear",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdDay",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdMonth",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdYear",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "notes",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentStatus",
  "storageKey": null
},
v15 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100000000
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": (v15/*: any*/),
  "concreteType": "InvoiceEntryTypeConnection",
  "kind": "LinkedField",
  "name": "entries",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "InvoiceEntryTypeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InvoiceEntryType",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantityText",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unitPrice",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "discount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "tax",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quickbooksItemOrService",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "entries(first:100000000)"
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "day",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "year",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fullName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateInvoicePayload",
        "kind": "LinkedField",
        "name": "updateInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceType",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": (v15/*: any*/),
                "concreteType": "InvoicePaymentTypeConnection",
                "kind": "LinkedField",
                "name": "payments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoicePaymentTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoicePaymentType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v13/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "payments(first:100000000)"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateInvoiceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateInvoicePayload",
        "kind": "LinkedField",
        "name": "updateInvoice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceType",
            "kind": "LinkedField",
            "name": "invoice",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v17/*: any*/),
              {
                "alias": null,
                "args": (v15/*: any*/),
                "concreteType": "InvoicePaymentTypeConnection",
                "kind": "LinkedField",
                "name": "payments",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoicePaymentTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "InvoicePaymentType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v13/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/),
                          (v21/*: any*/),
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Person",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                              (v23/*: any*/),
                              (v16/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "payments(first:100000000)"
              },
              (v16/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "695df9b1fe950005320ab7de4d22b519",
    "id": null,
    "metadata": {},
    "name": "updateInvoiceMutation",
    "operationKind": "mutation",
    "text": "mutation updateInvoiceMutation(\n  $input: UpdateInvoiceInput!\n) {\n  updateInvoice(input: $input) {\n    invoice {\n      invoiceReference\n      name\n      currency\n      invoiceType\n      status\n      dueDay\n      dueMonth\n      dueYear\n      createdDay\n      createdMonth\n      createdYear\n      notes\n      paymentStatus\n      entries(first: 100000000) {\n        edges {\n          node {\n            id\n            name\n            quantity\n            quantityText\n            unitPrice\n            discount\n            tax\n            description\n            quickbooksItemOrService\n          }\n        }\n      }\n      payments(first: 100000000) {\n        edges {\n          node {\n            id\n            notes\n            amount\n            day\n            month\n            year\n            createdAt\n            createdBy {\n              fullName\n              id\n            }\n          }\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "72cd498206bd0776a1c2449df37ef121";

export default node;
